import React from "react";
import ReactDOM from "react-dom";
import Wizard from "./components/open-week-wizard";

document.addEventListener("turbo:load", function () {
  const el = document.querySelector("[data-behavior='open-week-form']");

  if (el != null) {
    ReactDOM.render(<Wizard />, el);
  }
});
